import { createContext, useContext, ReactNode } from 'react';

import { useConversationLayout } from './conversationLayout.hooks';
import { ConversationLayoutContextValue } from './conversationLayout.types';

type Props = {
  children: ReactNode;
};

const ConversationLayoutContext = createContext({} as ConversationLayoutContextValue);

export const useConversationLayoutContext = () => useContext(ConversationLayoutContext);

export const ConversationLayoutProvider = ({ children }: Props) => {
  const value = useConversationLayout();

  return (
    <ConversationLayoutContext.Provider value={value}>
      {children}
    </ConversationLayoutContext.Provider>
  );
};
